import { getCoupleDisplayFullName } from "utils/getCoupleDisplayName";
import styles from "./AudioSessionInfo.module.scss";
import moment from "moment-timezone";
import getClasses from "utils/getClasses";
import PatientTypeTag from "../../patient-charts/components/patient-type-tag/PatientTypeTag";
import { useMemo } from "react";

const AudioSessionInfo = ({ appointment }) => {
  const patientType = useMemo(() => {
    if (!appointment) {
      return "adult";
    }

    const isMinor = !!appointment?.guardians?.length;
    if (isMinor) {
      return "minor";
    }

    const isCouple = !!appointment?.couple?.length;
    if (isCouple) {
      return "couple";
    }

    return "adult";
  }, [appointment]);
  const patientDob = moment(appointment?.patient?.dob);
  const formattedPatientDob = patientDob.format("MM/DD/YYYY");
  const patientAge = moment().diff(patientDob, "years");
  const formattedStart = appointment?.appointment_start
    ? moment(appointment.appointment_start).format(
        "dddd, MMM. D, YYYY - h:mm A z",
      )
    : "";

  return (
    <div className={styles["audio-content__session-info"]}>
      <div className={`${styles["audio-content__session-info-first-row"]}`}>
        <b className={"bd-16"}>
          {patientType === "couple" && appointment?.couple?.length
            ? getCoupleDisplayFullName(appointment?.couple)
            : `${appointment?.patient.first_name || ""}
          ${appointment?.patient.last_name || ""}`}{" "}
        </b>
        <span className={styles["audio-content__dob"]}>
          {!appointment?.patient?.dob
            ? ""
            : `${formattedPatientDob} (${patientAge})`}
        </span>
      </div>
      <div className={"d-flex align-items-center"}>
        <div
          className={getClasses("mr-2", styles["audio-content__header-text"])}
        >
          <PatientTypeTag type={patientType} />
        </div>
        <div className={styles["audio-content__header-text"]}>Client</div>

        <div
          className={getClasses(
            "mr-2",
            "ml-2",
            styles["audio-content__header-text"],
          )}
        >
          {formattedStart || ""}
        </div>
        <div
          className={getClasses(
            "mr-2",
            styles["audio-content__header-text"],
            styles["audio-content__session-type"],
          )}
        >
          {appointment?.appointment_type_label || ""}
        </div>
      </div>
    </div>
  );
};

export default AudioSessionInfo;
